<template>
  <div class="device-change">
    <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
      <slot name="other-form-item"></slot>
      <div v-for="(detailItem, i) in form.detail" :key="i">
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>
                {{ detailItem.title }}
              </p>
              <p @click="deviceCheckClick(i)">批量选择设备</p>
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in detailItem.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="detailItem.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick(i, index, '+')">+</p>
              <p :class="detailItem.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick(i, index, '-')">-</p>
            </div>
            <div class="contItem">
              <el-icon class="delIcon" v-if="index !== 0" @click="delControl(i, index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceSelectClick(i, index)"></el-input>
                <!-- 验证 -->
                <div class="form-item" style="height: 0; overflow: hidden">
                  <el-form-item :prop="`detail.${i}.items.${index}.dictName`" :rules="rules.dictName"></el-form-item>
                </div>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
                <div class="copy" @click="copyControl(i, index)" v-if="item.dictName">
                  <el-icon :size="20" color="#409eff">
                    <document-copy />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl(i)">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <slot :name="'slotName' + i"></slot>
      </div>
    </el-form>
    <deviceDictSelect v-if="deviceDictVisible" :deviceDictVisible="deviceDictVisible" @deviceDictVisibleFun="deviceDictVisible = $event" @checkDeviceDictListFun="handleDictSelect" />
    <deviceDictCheck
      v-if="deviceDictCheckVisible"
      :isMultiple="true"
      :checkDeviceList="checkDeviceList"
      :deviceVisible="deviceDictCheckVisible"
      @deviceVisibleFun="deviceDictCheckVisible = $event"
      @checkDeviceListFun="handleDictCheck"
    />
  </div>
</template>

<script setup>
// 1. 导入依赖（按需删除/添加）
import { ref, defineEmits, defineProps, watch, defineExpose } from "vue";
import letterList from "@/assets/js/letterList";

import deviceDictCheck from "./component/deviceDictCheck.vue";
import deviceDictSelect from "./component/deviceDictSelect.vue";
const props = defineProps({
  rules: {
    type: Object,
    default: () => {
      return {};
    },
  },
  form: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
const emit = defineEmits(["update:form"]);
// 表单引用
const formRef = ref();
const form = ref(props.form);

// 暴露表单验证方法给父组件
const validateForm = () => {
  return new Promise((resolve) => {
    // 调用 el-form 的 validate 方法进行校验
    formRef.value.validate((valid) => {
      resolve(valid); // 将校验结果（true/false）返回给父组件
    });
  });
};
// 重置表单
const resetForm = () => {
  formRef.value?.resetFields();
};

const deviceDictVisible = ref(false); // 是否显示
const currentPumpIdx = ref(null); // 当前点击的索引1
const currentField = ref(null); // 当前点击的索引2
function deviceSelectClick(i, index) {
  currentPumpIdx.value = i;
  currentField.value = index;
  deviceDictVisible.value = true;
}

/**
 * 处理字典选择事件
 * @param {Array} data - 选中的字典数据数组，包含单位、字典键、字典名称、设备ID和设备名称等信息
 */
function handleDictSelect(data) {
  // 构造要更新的项目对象
  let items = {
    unit: data[0].unit,
    dictKey: data[0].dictKey,
    dictName: data[0].dictName,
    deviceIdStr: data[0].deviceId,
    deviceName: data[0].deviceName,
  };

  // 将选中的字典信息合并到表单当前泵浦和字段的对应位置
  form.value.detail[currentPumpIdx.value].items[currentField.value] = { ...form.value.detail[currentPumpIdx.value].items[currentField.value], ...items };

  // 关闭设备字典选择弹窗
  deviceDictVisible.value = false;
}

// 批量选择设备
const deviceDictCheckVisible = ref(false); // 是否显示
const checkDeviceIndex = ref(); // 当前点击的索引
const checkDeviceList = ref([]); // 选中列表
// 批量选择设备点击
const deviceCheckClick = (i) => {
  // 重置选中列表
  if (i != checkDeviceIndex.value) {
    checkDeviceList.value = [];
  }
  checkDeviceIndex.value = i;
  deviceDictCheckVisible.value = true;
};
// 批量选择设备返回
const handleDictCheck = (data) => {
  let formula = "";
  let items = [];
  data.forEach((item, i) => {
    items.push({
      val: "",
      type: "1",
      unit: item.unit,
      dictKey: item.dictKey,
      dictName: item.dictName,
      name: letterList()[i].name,
      deviceIdStr: item.id,
      deviceName: item.name,
    });
    if (i == 0) {
      formula += letterList()[i].name;
    } else {
      formula += "+" + letterList()[i].name;
    }
  });
  form.value.detail[checkDeviceIndex.value].items = items;
  form.value.detail[checkDeviceIndex.value].formula = formula;
  checkDeviceList.value = data;
};

/**
 * 符号点击处理函数
 * @param {number} i - 表示detail数组中的第几项
 * @param {number} index - 表示公式中符号的位置索引
 * @param {string} symbol - 要插入的符号
 */
const symbolClick = (i, index, symbol) => {
  // 将当前公式的字符串转换为字符数组，便于修改指定位置的符号
  let formulaArr = form.value.detail[i].formula.split("");
  // 修改指定位置的符号（索引为2*index-1）
  formulaArr[2 * index - 1] = symbol;
  // 将修改后的字符数组重新组合成字符串并更新到表单数据中
  form.value.detail[i].formula = formulaArr.join("");
};

// 添加指标
const addControl = (i) => {
  form.value.detail[i].items.push({
    val: "",
    type: "1",
    unit: "",
    dictKey: "",
    dictName: "",
    name: letterList()[form.value.detail[i].items.length].name,
    deviceIdStr: "",
    deviceName: "",
  });
  // 更新公式字符串，添加新的变量名（如B、C等）
  form.value.detail[i].formula += "+" + letterList()[form.value.detail[i].items.length - 1].name;
};
// 复制指标
const copyControl = (i, index) => {
  let formula = JSON.parse(JSON.stringify(form.value.detail[i].formula));
  let data = JSON.parse(JSON.stringify(form.value.detail[i].items[index]));
  data.name = letterList()[form.value.detail[i].items.length].name;
  formula += "+" + data.name;
  form.value.detail[i].formula = formula;
  form.value.detail[i].items.push(data);
};
// 删除指标
const delControl = (i, index) => {
  // 删除指定位置的指标
  form.value.detail[i].items.splice(index, 1);
  // 删除选中设备
  checkDeviceList.value.splice(index, 1);
  // 更新公式字符串
  updateFormula(i, index);
};
const updateFormula = (i, index) => {
  let formulaArr = form.value.detail[i].formula.split("");
  // 删除对应的符号（索引为2*index-1）
  formulaArr.splice(2 * index - 1, 2);
  // 将修改后的字符数组重新组合成字符串并更新到表单数据中
  form.value.detail[i].formula = formulaArr.join("");
};

watch(
  () => props.form,
  (val) => {
    emit("update:form", val);
  },
  { deep: true, immediate: true }
);

// 暴露方法，让父组件可以调用
defineExpose({
  validateForm,
  resetForm,
});
</script>

<style scoped lang="scss">
.contentItem {
  width: calc(100% - 60px);
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  background: #f6f8fc;
  border: 1px solid #ebedfd;
  padding: 10px;
  margin-left: 20px;

  .liItemBox {
    width: 160px;
    height: 100px;
    background: #ffffff;
    padding: 16px;
    margin: 10px 36px 10px 26px;

    .bgc {
      min-width: 160px;
      width: 140px;
      height: 100%;
      background: rgba(22, 93, 255, 0.05);
      box-shadow: inset 0px 0px 20px 0px rgba(22, 93, 255, 0.1);
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 56px;
        height: 56px;
        margin-bottom: 8px;
      }

      > p:first-of-type {
        font-size: 16px;
      }

      > p:nth-of-type(2) {
        font-size: 12px;
        color: #409eff;
        cursor: pointer;
      }
    }
  }

  .el-radio-group {
    display: block;

    .el-radio {
      margin-right: 15px !important;
    }
  }

  > p,
  > div {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .contItemBox {
    align-items: center;
    margin: 10px 10px 10px 0;

    .symbol {
      margin-right: 10px;
      font-size: 20px;
      text-align: center;
      width: 16px;

      p {
        cursor: pointer;
        margin: 0;
      }

      .activeSymbol {
        color: #165dff;
        font-weight: bold;
      }
    }

    .symbol2 {
      margin-top: 50px;
    }
  }

  .addIcon,
  .delIcon {
    font-size: 17px;
    color: #000;
    cursor: pointer;
  }

  .addBox {
    width: 160px;
    height: 160px;
    border: 1px dashed #000;
    margin: 10px 0 0 10px;
    text-align: center;
    line-height: 160px;
    font-size: 40px;
    color: #000;
    cursor: pointer;
  }

  .contItem {
    display: flex;
    flex-direction: column;
    width: 160px;
    height: 100px;
    background: #ffffff;
    padding: 16px;
    position: relative;

    .delIcon {
      position: absolute;
      top: 8px;
      right: 6px;
      color: #5d5d5d;
      font-size: 18px;
      z-index: 1;
    }

    .el-select,
    .el-input {
      width: 160px;
      height: 30px;
      margin-right: 0;
    }

    .contTime .el-input {
      width: 110px;
      height: 30px;
    }

    .el-input__wrapper {
      height: 30px;
    }

    .contBox {
      position: relative;

      .el-select {
        margin-top: 20px;
      }
      .copy {
        position: absolute;
        left: -12px;
        top: -12px;
        width: 20;
        height: 20;
        cursor: pointer;
      }

      .center {
        span {
          color: #666666;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          background: rgba(51, 51, 51, 0.1);
          border-radius: 3px;
          margin-top: 10px;
          display: inline-block;
          padding: 3px 8px;
        }

        //.val .el-input__wrapper {
        //  box-shadow: 0 0 0 0;
        //  background-color: #f6f6f6;
        //}
        .val {
          margin-top: 30px;

          .el-input__wrapper {
            box-shadow: 0 0 0 0;
          }
        }

        .val .el-input__inner {
          font-size: 28px;
          color: #000;
        }

        .val .el-input__inner::placeholder {
          font-size: 12px;
          vertical-align: middle;
        }
      }

      .unit {
        text-align: right;
        position: absolute;
        top: 25px;
        right: 0;
      }
    }

    .contItem:hover .delIcon {
      display: block;
    }
  }

  .bagClass {
    .el-select__wrapper {
      width: 220px;
    }
  }
}
</style>
